import React from 'react';
import { connect } from "react-redux";
import { push } from 'react-router-redux';
import { branch, compose, renderComponent } from "recompose";
import { bindActionCreators } from 'redux';
import { isBusinessAdmin } from '../../../../services';
import Loading from '../../loading';
import SetTaskContent from './partials/set-task-content';

const TaskDetails = () => (<div id="task-details">
  <SetTaskContent checkBackdate={true} />
</div>);

const mapStateToProps = (state) => ({
  isBusinessAdmin: isBusinessAdmin(state.user.currentUser)
});

const mapDispatchToProps = (dispatch) => ({
  goTo: bindActionCreators(push, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ isBusinessAdmin }) => !isBusinessAdmin,
    renderComponent(Loading)
  )
)(TaskDetails)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/task-details.js